var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fulfilling-square-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"spinner-inner",style:(_vm.spinnerInnerStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }